export enum NotificationType {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}
